import { render, staticRenderFns } from "./VuesticMediumEditor.vue?vue&type=template&id=0b32c076"
import script from "./VuesticMediumEditor.vue?vue&type=script&lang=js"
export * from "./VuesticMediumEditor.vue?vue&type=script&lang=js"
import style0 from "./VuesticMediumEditor.vue?vue&type=style&index=0&id=0b32c076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-medium-editor/VuesticMediumEditor.vue
// module id = u+5M
// module chunks = 41